import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { EntrySpareComponent } from '../../facility/entry-spare/entry-spare.component';
import { ProviderService } from '../../service/provider.service';
import { AuthState } from '../../store/authInfo/auth-state';
// import { EntrySpareComponent } from '../../facility/entry-spare/entry-spare.component';
import { ContractEvaluateComponent } from './contract-evaluate/contract-evaluate.component';
import { ContractComponent } from './contract/contract.component';

@Component({
  selector: 'app-provider-contract-manager',
  templateUrl: './provider-contract-manager.component.html',
  styleUrls: ['./provider-contract-manager.component.less']
})
export class ProviderContractManagerComponent implements OnInit {
  @Input() pno: any; // 供应商编号
  status = ['签约', '执行' , '未执行', '终止', '废弃'];
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  // 查询结果
  data = [];
  validateForm: FormGroup;
  authState = null;
  checked = false;
  indeterminate = false;
  isShowLeft = true;
  isShowDown = false;
  directors = []; // 项目负责人列表
  setOfCheckedId = new Set<number>();
  constructor(
    private modalService: NzModalService,
    private message: NzMessageService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private store: Store,
  ) { }

  async ngOnInit(): Promise<void> {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.validateForm = this.fb.group({
      contractNo: [null], // 供应商名称
      contractName: [null],
      projectLeader: [null],
      status: [null],
      pno: this.pno
    });
    this.queryContractData(1);
    await this.providerService.getDirectors().then((data) => {
      this.directors = data;
    });
  }
  addContract(){
    const modal = this.modalService.create({
      nzTitle: '添加供应商合同',
      nzContent: ContractComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 0, // 添加
        pno: this.pno
      },
      nzOnOk: (ev) => {
        const  contractForm  = ev.getContractForm();
        const filePaths =  ev.getFilePathList();
        if (!this.validateFormData(contractForm)){
          this.message.warning('数据未验证通过');
          return false;
        }else{
          const  contract = {
            contractName : contractForm.value.contractName,
            contractNo : contractForm.value.contractNo,
            contractMoney: contractForm.value.contractMoney,
            signContractDate: contractForm.value.signContractDate,
            startContractDate: contractForm.value.startContractDate,
            endContractDate: contractForm.value.endContractDate,
            payDirect: contractForm.value.payDirect,
            contractDate: contractForm.value.contractDate,
            payMethod: contractForm.value.payMethod,
            status: contractForm.value.status,
            providerLeader: contractForm.value.providerLeader,
            projectLeader: contractForm.value.projectLeader,
            contractContent: contractForm.value.contractContent,
            mark: contractForm.value.mark,
            createBy: this.authState.userInfo.userId,
            pno: contractForm.value.pno,
            filePaths
          };
          // tslint:disable-next-line:no-shadowed-variable
          this.providerService.addContract(contract).subscribe((data: any) => {
            if (!this.isEmpty(data)){
              this.queryContractData(1);
              this.message.success('添加成功');
              modal.close();
            }else{
              this.message.error('添加失败');
            }
          });
          return false;
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  viewEntrySpare(item){
    const modal = this.modalService.create({
      nzTitle: '查看入库单',
      nzContent: EntrySpareComponent,
      nzStyle: { top: '20px' },
      // nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 1400,
      nzComponentParams: {
        cno: item.contractNo // 供应商合同id
      },
      nzOnOk: (ev) => {
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  viewContract(item){
    const modal = this.modalService.create({
      nzTitle: '查看供应商合同',
      nzContent: ContractComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 2, // 查看
        pno: this.pno,
        cid: item.id // 供应商合同id
      },
      nzOnOk: (ev) => {
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  editContract(item){
    const modal = this.modalService.create({
      nzTitle: '修改供应商合同',
      nzContent: ContractComponent,
      nzStyle: { top: '20px' },
      nzBodyStyle: { paddingRight: '0px', paddingLeft: '42px' },
      nzWidth: 700,
      nzComponentParams: {
        code: 1, // 编辑
        pno: this.pno,
        cid: item.id // 供应商合同id
      },
      nzOnOk: (ev) => {
        this.modalService.confirm({
          nzTitle: '修改合同',
          nzContent: '确定要修改合同内容？',
          nzOkText: '确定',
          nzCancelText: '取消',
          nzOnOk: () => {
            const  contractForm  = ev.getContractForm();
            const filePaths =  ev.getFilePathList();
            if (!this.validateFormData(contractForm)){
              this.message.warning('数据未验证通过');
            }else{
              const  contract = {
                id: item.id,
                contractName : contractForm.value.contractName,
                contractNo : contractForm.value.contractNo,
                contractMoney: contractForm.value.contractMoney,
                signContractDate: contractForm.value.signContractDate,
                startContractDate: contractForm.value.startContractDate,
                endContractDate: contractForm.value.endContractDate,
                payDirect: contractForm.value.payDirect,
                contractDate: contractForm.value.contractDate,
                payMethod: contractForm.value.payMethod,
                status: contractForm.value.status,
                providerLeader: contractForm.value.providerLeader,
                projectLeader: contractForm.value.projectLeader,
                contractContent: contractForm.value.contractContent,
                mark: contractForm.value.mark,
                updateBy: this.authState.userInfo.userId,
                pno: contractForm.value.pno,
                filePaths
              };
              // tslint:disable-next-line:no-shadowed-variable
              this.providerService.updateProviderContract(contract).subscribe((data: any) => {
                if (!this.isEmpty(data)){
                  // this.queryContractData(1);
                  this.message.success('修改成功');
                  modal.close();
                }else{
                  this.message.error('修改失败');
                }
              });
            }
            return true;
          }
        });
        return false;
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  // 评价
  evaluateContract(item, code){
    if (code === 0 ){
      // 供应商合同评价
      const modal = this.modalService.create({
        nzTitle: '合同评价',
        nzContent: ContractEvaluateComponent,
        nzComponentParams: {
          code: 0, // 0 评价 1 查看评价详情
          pno: this.pno,
          cid: item.id // 供应商合同id
        },
        nzStyle: { top: '20px' },
        nzWidth: 400,
        nzOnOk: (ev) => {
          this.modalService.confirm({
            nzTitle: '合同评价',
            nzContent: '评价后内容不可修改，请确认评价内容是否正确？',
            nzOkText: '确定',
            nzCancelText: '取消',
            nzOnOk: () => {
              const  contractForm  = ev.getForm();
              if (!this.validateFormData(contractForm)){
                this.message.warning('数据未验证通过');
              }else{
                const  contract = {
                  id: item.id,
                  responseTimeEvaluation : contractForm.value.responseTimeEvaluation,
                  serviceEfficiencyQualityEvaluation : contractForm.value.serviceEfficiencyQualityEvaluation,
                  servicePrice: contractForm.value.servicePrice,
                  otherEvaluation: contractForm.value.otherEvaluation,
                  updateBy: this.authState.userInfo.userId,
                  evaluator: this.authState.userInfo.userId,
                  pno: this.pno
                };
                // tslint:disable-next-line:no-shadowed-variable
                this.providerService.evaluateProviderContract(contract).subscribe((data: any) => {
                  if (!this.isEmpty(data)){
                    this.queryContractData(1);
                    this.message.success('评价成功');
                    modal.close();
                  }else{
                    this.message.error('评价失败');
                  }
                });
              }
              return true;
            }
          });
          return false;
        },
        nzOnCancel: (ev) => {
        }
      });
    }else{
      // 查看供用商合同评价详情
      const modal = this.modalService.create({
        nzTitle: '查看合同评价',
        nzContent: ContractEvaluateComponent,
        nzComponentParams: {
          code: 1, // 编辑
          pno: this.pno,
          cid: item.id // 供应商合同id
        },
        nzStyle: { top: '20px' },
        nzWidth: 400,
        nzOkText: null,
        nzOnOk: (ev) => {
        },
        nzOnCancel: (ev) => {
        }
      });
    }
  }
  onAllChecked(checked: boolean): void {
    this.data.forEach(item => this.updateCheckedSet(item.id, checked));
    this.refreshCheckedStatus();
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  refreshCheckedStatus(): void {
    this.checked = this.data.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.data.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  onPageIndexChange(pageIndex) {
    this.pageIndex = pageIndex;
  }
  // 提交表单
  submitForm() {
    this.validateForm.setValue({
      contractNo: this.validateForm.value.contractNo,
      contractName: this.validateForm.value.contractName,
      projectLeader: this.validateForm.value.projectLeader,
      status: this.validateForm.value.status,
      pno: this.pno
    });
    this.queryContractData(1);
  }
  // 重置表单
  resetForm() {
    this.validateForm.setValue({
      contractNo: null,
      contractName: null,
      projectLeader: null,
      status: null,
      pno: this.pno
    });
    this.queryContractData(1);
  }
  queryContractData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    // tslint:disable-next-line:max-line-length
    this.providerService.getProviderContractsByCondition(this.validateForm.value, this.pageIndex, this.pageSize).subscribe((data: any) => {
      this.loading = false;
      this.data = data.list;
      this.total = data.total;
    });
  }
  openOtherCondition(){
    this.isShowLeft = false;
    this.isShowDown = true;
  }

  closeOtherCondition(){
    this.isShowLeft = true;
    this.isShowDown = false;
  }
  delete(){
    this.providerService.batchDeleteContracts(this.setOfCheckedId).subscribe((data: any) => {
      if (data > 0){
        this.queryContractData(1);
      }
    });
  }
  public validateFormData(validateForm) {
    // tslint:disable-next-line:forin
    for (const i in validateForm.controls) {
      validateForm.controls[i].markAsDirty();
      validateForm.controls[i].updateValueAndValidity();
    }
    return validateForm.valid;
  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
